var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.66675H3.33333V7.33341H0V8.66675ZM4.33333 8.66675H7.66667V7.33341H4.33333V8.66675ZM8.66667 8.66675H12V7.33341H8.66667V8.66675ZM0 11.3334H1.33333V10.0001H0V11.3334ZM2.66667 11.3334H4V10.0001H2.66667V11.3334ZM5.33333 11.3334H6.66667V10.0001H5.33333V11.3334ZM8 11.3334H9.33333V10.0001H8V11.3334ZM10.6667 11.3334H12V10.0001H10.6667V11.3334ZM0 6.00008H5.33333V4.66675H0V6.00008ZM6.66667 6.00008H12V4.66675H6.66667V6.00008ZM0 0.666748V3.33341H12V0.666748H0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.67aabd194bdd1b7beec800c06490251a.svg";
export { ForwardRef as ReactComponent };